import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,[_c('div',{staticClass:"d-flex justify-end"},[_c('img',{staticClass:"mt-3 mr-3",attrs:{"src":require('./assets/logo.png'),"height":"100"}})]),_c(VMain,[_c('buchung')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }